import React from 'react';
import audienceCreditScore from './images/audience-credit-score.svg';
import audienceDebt from './images/audience-debt.svg';
import audienceMinimumPayment from './images/audience-minimum-payment.svg';
import InfoSection from '../common/components/info-section/InfoSection';

function Audience() {
  const title = <React.Fragment>How do you know if Sera is for you?</React.Fragment>;
  const subtitle = 
    <React.Fragment>
      Sera helps people who are struggling with credit card debt. We can even help those with poor credit who no one else is willing or able to help.
    </React.Fragment>
  const audienceTypes = [
    {
      img: audienceCreditScore,
      title: <React.Fragment>Is your credit score holding you back?</React.Fragment>,
      description: 
        <React.Fragment>
          A low credit score can be costly and limit financial options. Enhancing your creditworthiness is a challenging and time-consuming process. Irrespective of your circumstances, Sera's primary focus is on addressing this concern promptly and discovering effective methods to boost your credit score.
        </React.Fragment>
    },
    {
      img: audienceMinimumPayment,
      title: <React.Fragment>Are you able to make only the minimum monthly payments?</React.Fragment>,
      description: 
        <React.Fragment>
          Even if you can't afford to make more than the minimum monthly payment on your credit card debt, Sera can help show you how to leverage your checking account balance to lower the amount of interest on your debt each month.
        </React.Fragment>
    },
    {
      img: audienceDebt,
      title: <React.Fragment>Do you need to control your spending to prevent accruing more debt?</React.Fragment>,
      description: 
        <React.Fragment>
          By connecting your checking account and your credit card to Sera, we can not only determine the monthly amount of credit card expenses to offset your debt, but also can provide you with a budget to prevent any more debt addition. If you need a complete family budget enforcement, use our premium feature to connect all accounts so Sera can track, alert, and enforce your family budget for you to ensure you live within your means.
        </React.Fragment>
    }
  ]
  return (
    <InfoSection title={title} subtitle={subtitle} items={audienceTypes} />
  )
}

export default Audience;